import isNil from "lodash/fp/isNil";

class Controller {
  constructor(
    Events,
    $stateParams,
    CityHandler,
    VariablePlansTransforms,
    Sections
  ) {
    "ngInject";

    this.CityHandler = CityHandler;
    this.VariablePlansTransforms = VariablePlansTransforms;

    this.addItemEvent = Events.getAddEvent("variablePlans");
    this.paginateEvent = Events.getPaginateEvent("variablePlans");
    this.filterEvent = Events.getFilterEvent("variablePlans");
    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.sections = Sections.plansSections;
  }

  $onInit() {
    const chosenCity = this.CityHandler.get();

    if (!isNil(chosenCity)) {
      chosenCity.name = chosenCity.title;
    }
    this.VariablePlansTransforms.addOptions.fields[1].value = chosenCity;
    this.VariablePlansTransforms.addOptions.fields[1].isDisabled = Boolean(
      chosenCity
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/variablePlans/variablePlans.controller.js